import { render, staticRenderFns } from "./AiModal.vue?vue&type=template&id=72d21220&scoped=true&"
import script from "./AiModal.vue?vue&type=script&lang=js&"
export * from "./AiModal.vue?vue&type=script&lang=js&"
import style0 from "./AiModal.vue?vue&type=style&index=0&id=72d21220&prod&scoped=true&lang=css&"
import style1 from "./AiModal.vue?vue&type=style&index=1&id=72d21220&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d21220",
  null
  
)

export default component.exports
import {QIcon,QSkeleton,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QIcon,QSkeleton,QBtn})
